<div class="header text-center">
    <h2 class="m-0 font-bold">Your Discount Codes</h2>
    <p class="m-0">Select a code below to use on your purchase</p>
</div>
<mat-action-list>
    <!-- <button *ngIf="promo && promo.code" class="coupon-option coupon-limited" [class.xmas]="ss.isChristmasTime" [class.valentine]="pkg == 'yearly' && ss.isValentines" mat-list-item (click)="select(promo.code)">
        <h3 matLine class="code" extrabold>{{promo.code.toUpperCase()}}</h3>
        <p matLine>{{promo && promo.submsg || 'LIMITED TIME OFFER'}}</p> 
        <p class="righty" bold>
            {{promo.off}}
        </p>
    </button> -->
    @for(use of parsed_uses(); track use._id){
        <button class="coupon-option" mat-list-item (click)="select(use.code)">
            <div class="f-main-between f-cross-center">
                <div>
                    <h3 class="m-0 code font-regular">
                        <span class="font-extrabold">{{use.code}}</span>
                        @if(use.expiry){
                            <span class="promo-text">({{use.expiry}})</span> 
                        }
                    </h3>
                    <p class="m-0">
                        {{package()?.short_name}}{{package()?.price ? ' - ' + use.discount + ' OFF' : ''}}
                    </p> 
                </div>
                <div>
                    <p class="m-0 font-bold" paint="warn">
                        <span class="discounted-price">{{use.price}}</span>
                        @if(use.free_days){
                            <br/>
                            <span class="font-regular">FOR {{use.free_days}} DAY{{use.free_days == 1 ? '' : 'S'}}</span>
                        }
                    </p>
                </div>
            </div>
        </button>
    }
    <button mat-list-item (click)="select('')" class="coupon-new"> 
        <h3 matLine paint="warn" class="font-light">I have a different code</h3>
    </button>
</mat-action-list>